import axios from 'axios';
import keycloak from '../keycloak';

const normalizeBaseUrl = (url) => {
    if (!url) {
        throw new Error(
            'A variável REACT_APP_API_URL não está configurada.'
        );
    }

    return url.endsWith('/') ? url : `${url}/`;
};

const apiUrl = normalizeBaseUrl(
    process.env.REACT_APP_API_URL
);

const axiosInstance = axios.create({
    baseURL: apiUrl,
    timeout: 30000,
    headers: {
        Accept: 'application/json',
    },
});

let refreshPromise = null;

const refreshKeycloakToken = async () => {
    if (!keycloak.authenticated) {
        return null;
    }

    if (!refreshPromise) {
        refreshPromise = keycloak
            .updateToken(30)
            .catch((error) => {
                console.error(
                    'Erro ao renovar o token Keycloak:',
                    error
                );

                throw error;
            })
            .finally(() => {
                refreshPromise = null;
            });
    }

    await refreshPromise;

    return keycloak.token || null;
};

axiosInstance.interceptors.request.use(
    async (config) => {
        const token = await refreshKeycloakToken();

        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const status = error?.response?.status;

        if (
            status === 401
            && keycloak.authenticated
            && !error.config?._keycloakRetry
        ) {
            error.config._keycloakRetry = true;

            try {
                await keycloak.updateToken(-1);

                error.config.headers = error.config.headers || {};
                error.config.headers.Authorization =
                    `Bearer ${keycloak.token}`;

                return axiosInstance.request(error.config);
            } catch (refreshError) {
                console.error(
                    'Sessão Keycloak expirada:',
                    refreshError
                );

                await keycloak.logout({
                    redirectUri: window.location.origin,
                });
            }
        }

        return Promise.reject(error);
    }
);

export default class BaseApi {
    static getApiUrl() {
        return apiUrl;
    }

    static async startRequest() {
        await refreshKeycloakToken();
    }

    static getAxiosInstance() {
        return axiosInstance;
    }

    static async getAccessToken() {
        return refreshKeycloakToken();
    }
}